<template src="./template.html" />

<script>
import Btn from '@/components/elements/buttons';

export default {
  name: 'confirmation-bar',
  components: {
    Btn,
  },
  props: {
    showSavebar: {
      type: Boolean,
      default: false,
    },
    deleteAction: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm');
    },
    cancel() {
      this.$emit('cancel');
    },
  },
}
</script>
